var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCurl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.82843 5.99955L6.36396 8.5351L4.94975 9.9493L0 4.99955L4.94975 0.0498047L6.36396 1.46402L3.82843 3.99955H11C15.4183 3.99955 19 7.58127 19 11.9996C19 16.4178 15.4183 19.9996 11 19.9996H2V17.9996H11C14.3137 17.9996 17 15.3133 17 11.9996C17 8.68585 14.3137 5.99955 11 5.99955H3.82843Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCurl);
export default __webpack_public_path__ + "static/media/arrow-curl.da37648e1ee3dca7bd024b49d9c852cd.svg";
export { ForwardRef as ReactComponent };